// extracted by mini-css-extract-plugin
export default {"wrap":"mr-z","fullWidth":"nr-z","items":"or-z","featureCss":"pr-z","disabled":"qr-z","imgCss":"rr-z"};